import { atom } from 'jotai';

/**
 * doing: drvierJS 튜토리얼이 실행 중인 상태
 * done: driverJS 튜토리얼이 모두 끝난 상태
 */
const 튜토리얼_노출상태_리스트 = ['doing', 'done'] as const;

export type 튜토리얼_노출상태_타입 = (typeof 튜토리얼_노출상태_리스트)[number];

/**
 * 어떤 액션을 해야만 노출되는 튜토리얼이 있으므로
 * 초기값은 done으로 둔다.
 */
const 초기값 = 'done' as 튜토리얼_노출상태_타입;

export const 튜토리얼_노출상태_아톰 = atom(초기값);
